import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import Client from "../../models/Client";

import templateContent from "./client-detail-panel.html";

import clientManager from "../../managers/clientManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
// import organizationManager from "../../managers/organizationManager";

class ClientDetailPanelComponent extends Component {
	constructor () {
		super("clientDetailPanelComponent");

		this.addTemplate("", templateContent);
	}

	addClientBtn_clickHandler () {
		const editingClient = new Client({
			status: 1,
		});

		// Dave: questi sono temporanei
		editingClient.on("organizationGuidChanged", () => Shark.render());
		editingClient.on("statusChanged", () => Shark.render());
		
		Shark.set({
			editingClient,
			__isEditingClient: true,
		});

		Shark.render();
		this.open();
	}

	afterLoad () {
		const modalNode = document.querySelector("#clientDetailModal");
		
		if (modalNode) {
			this.modal = new Modal(modalNode);
		}
	}

	cancelClientEditBtn_clickHandler () {
		this.close();
	}

	close () {
		Shark.set({
			__isEditingClient: false,
		});

		if (this.modal) {
			this.modal.hide();
		}
	}

	editClientBtn_clickHandler (event, data) {
		const editingClient = Utils.safp(Shark.$store.clientList, "guid", data.guid);
		// console.log(editingClient);

		if (editingClient) {
			// Dave: questi sono temporanei
			editingClient.on("organizationGuidChanged", () => Shark.render());
			editingClient.on("statusChanged", () => Shark.render());

			Shark.set({
				editingClient,
			});
			editingClient.on("organizationGuid", this.clientDetailPanelOrganizationField_changeHandler);

			Shark.render(); // Dave: il fatto che un oggetto sia usato come data-sh-model potrebbe essere usato come inizializzatore dell'autoreder, come se ci fosse il "{{#editingClient}}" in pagina
			this.open();
		}
	}

	fastSaveField_keyupHandler (event) {
		// @Dave: mac users don't use control but command
		if (event.keyCode === 83 && event.ctrlKey) {
			this.saveEditingClient();
		}
	}

	init () {
		this.addComponents([waitBoxComponent]);

		Shark.set({
			editingClient: null,
			_saveEditingClientBtnStatusCSSClasses: "btn-primary",
			__isEditingClient: false,
		});
	}
	
	open () {
		if (this.modal) {
			this.modal.show();
		}		
	}


	clientDetailPanelOrganizationField_changeHandler () {
		const { editingClient } = Shark.get();
		document.querySelectorAll(`[data-sh-validate="organizationGuid"]`).forEach(item => editingClient.validateOrganizationGuid().length > 0 ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	}

	clientDetailPanelNameField_changeHandler () {
		const { editingClient } = Shark.get();
		// console.log(editingClient.validateName());
		document.querySelectorAll(`[data-sh-validate="name"]`).forEach(item => editingClient.validateName().length > 0 ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	}

	async saveEditingClient () {
		const { editingClient } = Shark.get();

		if (editingClient) {
			const errors = editingClient.validate();

			if (errors.length > 0) {
				errors.forEach(error => {
					document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
					setTimeout(function(){
						document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
					}, 250);
				});
				// ("Attenzione, si sono verificati i seguenti errori:\n\n" + errors.map(item => item.error).join("\n"));
			}
			else {
				Shark.set({
					_saveEditingClientBtnStatusCSSClasses: "btn-warning disabled",
				});
				await clientManager.save(editingClient);
				Shark.set({
					_saveEditingClientBtnStatusCSSClasses: "btn-success",
					newlyAddedProject: editingClient,
				});
				this.close();

				if (Shark.activePage.refreshClientList) {
					Shark.activePage.refreshClientList();
				}
				//Questo andrebbe fatto con un evento
				// if (Shark.activePage.refreshProjectList) {
				// 	Shark.activePage.refreshProjectList();
				// }
			}
		}
	}

	saveEditingClientBtn_clickHandler () {
		this.saveEditingClient();
	}

	toggleOpen () {
		if (Shark.$store.__clientDetailModalVisibile) {
			this.close();
		}
		else {
			this.open();
		}
	}

	toggleClientEditing () {
		// const { editingClient } = Shark.get();

		Shark.$store.__isEditingClient = !Shark.$store.__isEditingClient;
		// editingClient.updateScreenWithModelValues();
	}

	toggleClientEditingBtn_clickHandler () {
		const { editingClient } = Shark.get();

		if (Shark.$store.__isEditingClient && editingClient.isDirty()) {
			if (!confirm(Shark.$store.labels.warning_changes_not_saved)) {
				return;
			}

			if (editingClient.guid === "") {
				this.close();
			}
			else {
				editingClient.restore();
			}
		}

		if (editingClient.guid === "") {
			this.close();
		}
		else {
			this.toggleClientEditing();
		}
	}
}

const clientDetailPanelComponent = new ClientDetailPanelComponent();

Shark.registerComponent(clientDetailPanelComponent);

export default clientDetailPanelComponent;